import { createFileRoute } from '@tanstack/react-router'
import { AuthContainer } from '@/components/auth/AuthContainer'

export const Route = createFileRoute('/_unauth/login')({
  component: LoginPage,
})

function LoginPage() {
  return (
    <AuthContainer initialState="signIn" redirectTo="/dashboard" />
  )
}
